import { Card, Row, Col } from "react-bootstrap";

export default function SVCashClosingSummary({ data }) {
  const format = (num) => Number(num || 0).toFixed(2);
  const totalIngresos =
    (Number(data.ingresosEfectivo) || 0) + (Number(data.ingresosTarjeta) || 0);

  const diffCambio =
    (Number(data.cambioFinal) || 0) - (Number(data.cambioInicial) || 0);

  return (
    <div className="mt-4">
      <Row xs={1} md={3} className="g-4 text-center">
        {/* KPI 1: Ingresos */}
        <Col>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <Card.Title className="fw-semibold mb-3">Ingressos</Card.Title>
              <div className="d-flex justify-content-between text-muted small">
                <span>Efectiu</span>
                <span>{format(data.ingresosEfectivo)} €</span>
              </div>
              <div className="d-flex justify-content-between text-muted small">
                <span>Tarjeta</span>
                <span>{format(data.ingresosTarjeta)} €</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between fw-bold">
                <span>Total ingresat</span>
                <span>{format(totalIngresos)} €</span>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* KPI 2: Cambio inicial/final */}
        <Col>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <Card.Title className="fw-semibold mb-3">Canvi</Card.Title>
              <div className="d-flex justify-content-between text-muted small">
                <span>Inicial</span>
                <span>{format(data.cambioInicial)} €</span>
              </div>
              <div className="d-flex justify-content-between text-muted small">
                <span>Final</span>
                <span>{format(data.cambioFinal)} €</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between fw-bold">
                <span>Diferència</span>
                <span
                  className={
                    diffCambio > 0
                      ? "text-success"
                      : diffCambio < 0
                      ? "text-danger"
                      : ""
                  }
                >
                  {diffCambio > 0 ? "+" : ""}
                  {format(diffCambio)} €
                </span>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* KPI 3: Total guardado */}
        <Col>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <Card.Title className="fw-semibold mb-3">
                Total guardat a Caixa
              </Card.Title>
              <div className="display-6 fw-bold">
                {format(data.totalCaja)} €
              </div>
              <div className="text-muted small mt-2">Verificat</div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Comentarios (sección separada) */}
      {data.comentarios && (
        <div className="mt-5 p-3 border-start border-3 border-secondary bg-light rounded">
          <h6 className="text-secondary mb-2">Comentari</h6>
          <p className="mb-0">{data.comentarios}</p>
        </div>
      )}

      <div className="text-end mt-3 text-muted small">
        <div>
          Última actualització:{" "}
          {data.fechaActualizacion?.toDate
            ? data.fechaActualizacion.toDate().toLocaleString()
            : "—"}
        </div>
        <div>Usuari: {data.usuario || "—"}</div>
      </div>
    </div>
  );
}
